import { AppPages, VendorContactRole } from '@trnsact/trnsact-shared-types';
import { vendorContactRoleHumanReadable } from 'utils';
import { RoutingAccessPortalConfiguration } from '../types';

export const routingAccessDefaultConfig: RoutingAccessPortalConfiguration = {
  accessByPage: {
    [AppPages.AftermarketProducts]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.CompanyProfile]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.FinancePrograms]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.Inventory]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.LenderManagement]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.LocationManagement]: {
      rolesSettings: {
        hidden: [VendorContactRole.SalesRep],
      },
    },
    [AppPages.PortalSetup]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.PrescreenTools]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.UserManagement]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.WebsiteIntegrations]: {
      rolesSettings: {
        hidden: [VendorContactRole.SalesRep],
      },
    },
    [AppPages.Dashboard]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.Opportunities]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.Finance]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.SubmissionsHub]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.Customers]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.StartDeal]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.SendApplication]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.Leads]: {
      rolesSettings: {
        hidden: [],
      },
    },
    [AppPages.Reports]: {
      rolesSettings: {
        hidden: [],
      },
    },
    // preserves current hard-coded SalesRep exclusion for unconfigured accounts
    [AppPages.Tasks]: {
      rolesSettings: {
        hidden: [VendorContactRole.SalesRep],
      },
    },
    [AppPages.Docs]: {
      rolesSettings: {
        hidden: [],
      },
    },
  },
};

export const ADMIN_PAGES_ORDER: AppPages[] = [
  AppPages.CompanyProfile,
  AppPages.UserManagement,
  AppPages.LenderManagement,
  AppPages.FinancePrograms,
  AppPages.LocationManagement,
  AppPages.PortalSetup,
  AppPages.AftermarketProducts,
  AppPages.Inventory,
  AppPages.WebsiteIntegrations,
  AppPages.PrescreenTools,
];

export const PRIMARY_NAV_PAGES_ORDER: AppPages[] = [
  AppPages.Dashboard,
  AppPages.Opportunities,
  AppPages.Finance,
  AppPages.SubmissionsHub,
  AppPages.Customers,
  AppPages.StartDeal,
  AppPages.SendApplication,
  AppPages.Leads,
  AppPages.Reports,
  AppPages.Tasks,
  AppPages.Docs,
];

export const APP_PAGES_LABELS: Record<AppPages, string> = {
  [AppPages.CompanyProfile]: 'Company Profile',
  [AppPages.UserManagement]: 'User Management',
  [AppPages.LenderManagement]: 'Lender Management',
  [AppPages.FinancePrograms]: 'Finance Programs',
  [AppPages.LocationManagement]: 'Location Management',
  [AppPages.PortalSetup]: 'Portal Setup',
  [AppPages.AftermarketProducts]: 'Aftermarket Products',
  [AppPages.Inventory]: 'Inventory',
  [AppPages.WebsiteIntegrations]: 'Website Integration',
  [AppPages.PrescreenTools]: 'Prescreen Tools',
  [AppPages.Dashboard]: 'Dashboard',
  [AppPages.Opportunities]: 'Opportunities',
  [AppPages.Finance]: 'Finance',
  [AppPages.SubmissionsHub]: 'Submissions Hub',
  [AppPages.Customers]: 'Customers',
  [AppPages.StartDeal]: 'Start Deal',
  [AppPages.SendApplication]: 'Send Application',
  [AppPages.Leads]: 'Leads',
  [AppPages.Reports]: 'Reports',
  [AppPages.Tasks]: 'Tasks',
  [AppPages.Docs]: 'Docs',
};

export type RoleColumnConfig = { role: VendorContactRole; label: string };

export const ROLE_COLUMNS: RoleColumnConfig[] = [
  VendorContactRole.ItAdmin,
  VendorContactRole.SalesMgr,
  VendorContactRole.SalesRep,
  VendorContactRole.FinanceMgr,
  VendorContactRole.CreditMgr,
  VendorContactRole.Executive,
  VendorContactRole.SupportPerson,
].map(role => ({ role, label: vendorContactRoleHumanReadable[role] }));
